// src/lib/guards/requirePermission.ts
import { redirect } from '@tanstack/react-router';

import { useAuthStore } from '@/stores/authStore';
import { hasPermission, type Permission } from '@/lib/rbac';

/**
 * TanStack Router beforeLoad guard: require a specific permission.
 * Must be called AFTER requireAuth (or combined in a composed guard).
 * Redirects to /unauthorized if denied.
 */
export function requirePermission(permission: Permission): void {
  const { user } = useAuthStore.getState();
  if (!user || !hasPermission(user.role, permission)) {
    // /unauthorized registers in Phase 3.
    // eslint-disable-next-line @typescript-eslint/only-throw-error
    throw redirect({ to: '/unauthorized' });
  }
}
